import { useEffect, useState } from 'react';

import { MagicWandSvg } from '../../../../assets/icons/MagicWandSvg';
import theme from '../../../../assets/theme';
import {
  TemplateStateActions,
  useDesignerDataContext,
} from '../../../../hooks/useDesignerLogic';
import {
  DesignerUIStateActions,
  useDesignerUIContext,
} from '../../../../hooks/useDesignerUIState';
import { PromptSingleTestCaseResult } from '../../../../services/backendService/types';
import { Button } from '../../../_atoms/Button';
import { IconWrapper } from '../../../_atoms/IconWrapper';
import BaseModal from '../../../_molecules/BaseModal';
import GameImageRenderer from '../../../_molecules/GameImageRenderer';
import { MediaMimeType } from '../../../SlideComponents/slide.types';

export const PromptAIImageConnector = ({
  promptImageSourceId,
}: {
  promptImageSourceId: string;
}) => {
  const dispatch = useDesignerUIContext(context => context.dispatch);

  const selectedPromptSourceId = useDesignerUIContext(
    c => c.state.aiConnection?.promptImageSourceId,
  );

  return (
    <IconWrapper
      style={{
        borderRadius: 50,
        border:
          selectedPromptSourceId === promptImageSourceId
            ? '1px solid transparent'
            : '1px solid black',
        padding: 3,
        background:
          selectedPromptSourceId === promptImageSourceId
            ? theme.colors.purple
            : undefined,
        color:
          selectedPromptSourceId === promptImageSourceId ? theme.colors.white : undefined,
      }}
      onClick={() => {
        if (selectedPromptSourceId === promptImageSourceId) {
          dispatch({ type: DesignerUIStateActions.resetAIConnection });
        } else {
          dispatch({
            type: DesignerUIStateActions.setAIImagePromptSourceId,
            promptImageSourceId,
          });
        }
      }}
      height="12px"
      width="12px"
    >
      <MagicWandSvg />
    </IconWrapper>
  );
};

export const AIImageConnectorConfirmModal = ({
  promptImageResult,
}: {
  promptImageResult?: PromptSingleTestCaseResult;
}) => {
  const aiConnection = useDesignerUIContext(context => context.state.aiConnection);
  const isImageConnectionOpen =
    !!aiConnection?.promptImageSourceId && !!aiConnection?.aiImageElementId;

  const dispatch = useDesignerUIContext(context => context.dispatch);

  const dataDispatch = useDesignerDataContext(context => context.dispatch);

  const [exampleImage, setExampleImage] = useState<
    | {
        id?: string;
        mimetype: MediaMimeType;
        url?: string;
        thumbnail?: string;
        downloadLocation?: string;
      }
    | undefined
  >();

  const handleConfirm = () => {
    if (
      aiConnection?.promptImageSourceId &&
      aiConnection?.aiImageElementId &&
      exampleImage
    ) {
      dataDispatch({
        type: TemplateStateActions.convertImageElementToAIImageElement,
        promptImageSourceId: aiConnection.promptImageSourceId,
        elementId: aiConnection.aiImageElementId,
        exampleImage,
      });
      dispatch({ type: DesignerUIStateActions.resetAIConnection });
      dispatch({ type: DesignerUIStateActions.deselectElements });
    }
  };

  useEffect(() => {
    if (
      promptImageResult &&
      aiConnection?.promptImageSourceId &&
      aiConnection.aiImageElementId
    ) {
      // Modal is opened and we set the example image based on the prompt result
      const imageResult = promptImageResult[aiConnection.promptImageSourceId];
      if (!imageResult) return; // Don't set anything;

      const promptImage = {
        id: imageResult.value,
        mimetype: 'image/png' as MediaMimeType,
      };
      setExampleImage(promptImage);
    }
  }, [promptImageResult, aiConnection]);
  return (
    <>
      <BaseModal
        onCancel={() => {
          dispatch({ type: DesignerUIStateActions.resetAIConnection });
        }}
        title={`Connect and fill with example?`}
        visible={isImageConnectionOpen}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '20px',
            justifyContent: 'center',
          }}
        >
          <>
            {exampleImage && exampleImage.url && (
              <img
                key={exampleImage.id}
                style={{ width: '70%' }}
                src={exampleImage.url}
              />
            )}
            {exampleImage && exampleImage.id && (
              <GameImageRenderer
                key={exampleImage.id}
                fileId={exampleImage.id}
                fileMimetype={'image/png'}
                fileAltText={''}
                cropConfig={undefined}
                isDiscoverTemplate={false}
                isAuthenticated={true}
                isOwner={true}
              />
            )}
          </>
          <Button onClick={handleConfirm}>Connect and fill</Button>
        </div>
      </BaseModal>
    </>
  );
};
